<script>
  import { slide } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  
  export let results = [];
  export let visible = false;
  export let resultsText;
  
  const dispatch = createEventDispatcher();
  
  function toggleResults() {
    visible = !visible;
    dispatch('toggle', { visible });
  }
  
  function handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleResults();
    }
  }
</script>
  
  <style>
  .results {
    width: 100%;
    margin-bottom: 10px;
    margin-top: 20px;
    color: #ffffff;
  }
  
  .results button {
    background: none;
    border: none;
    color: #003476;
    font-size: 1.2em;
    text-align: left;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    margin: 0;
    width: 100%;
  }
  
  .results button:focus {
    outline: none;
  }
  
  .results button .arrow {
    margin-left: 5px;
    font-size: 1em;
    line-height: 1;
    display: flex;
    align-items: center;
  }
  
  .results ul {
    list-style-type: none;
    padding-left: 0;
    margin: 5px 0 0 0;
  }
  
  .results li {
    margin-bottom: 10px;
    position: relative;
    padding-left: 25px;
  }
  
  h3 {
    font-size: 1.3em;
    font-weight: bold;
    margin: 0;
    line-height: 1;
  }
  
  .result-item h4 {
    margin: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.3;
    max-height: 2.6em; /* 2 lines * 1.3 line-height */
  }
  
  .source-link {
    position: absolute;
    left: 0;
    top: 2px;
    color: #003476;
    text-decoration: none;
    font-size: 14px;
    line-height: 1.5;
  }
  
  .source-link:hover {
    text-decoration: underline;
  }
  
  .result-title {
    color: #003476;
    text-decoration: none;
  }
  </style>
  
  <div class="results {visible ? 'expanded' : 'collapsed'}">
    <button on:click={toggleResults} on:keydown={handleKeydown} tabindex="0">
      <h3>{resultsText}</h3>
      <span class="arrow">{visible ? '▲' : '▼'}</span>
    </button>
    {#if visible}
      <ul transition:slide={{ duration: 300 }}>
        {#if results && results.length > 0}
          {#each results as result, index}
            <li class="result-item">
              <a href={result.url} target="_blank" rel="noopener noreferrer" class="source-link">[{index + 1}]</a>
              <h4><a href={result.url} target="_blank" rel="noopener noreferrer" class="result-title">{result.title}</a></h4>
            </li>
          {/each}
        {:else}
          <p>No results found for your query. Please try a different query or check your spelling.</p>
        {/if}
      </ul>
    {/if}
  </div>